import { ElMessage } from 'element-plus';
import { queryNoticeList, readNotice, type ApiMessageRes } from '../apis/methods/notice';
import useNoticesStore from '../stores/modules/notices';
import { ref, onMounted, onUnmounted } from 'vue';

const useNotice = () => {
  const timer = ref<ReturnType<typeof setInterval>>();
  const tableData = ref<ApiMessageRes['list']>([]);
  const currentPage = ref(1);
  const limit = ref(9999);
  const total = ref(0);

  const TypeEnums: Record<number, { title: string; type: string }> = {
    1: {
      title: '公告',
      type: 'success',
    },
    2: {
      title: '提醒',
      type: 'warning',
    },
    3: {
      title: '更新',
      type: 'primary',
    },
    4: {
      title: '预警',
      type: 'danger',
    },
    5: {
      title: '其他',
      type: 'info',
    },
  };

  const handleSizeChange = (val: number) => {
    limit.value = val;
    queryList();
  };
  const handleCurrentChange = (val: number) => {
    limit.value = val;
    currentPage.value = 1;
    queryList();
  };

  const queryList = async () => {
    try {
      const { success, obj } = await queryNoticeList({ page: currentPage.value, limit: limit.value });
      if (success) {
        tableData.value = obj.list;
        total.value = obj.total;
        const noticesStore = useNoticesStore();
        noticesStore.updateUnreadCount(obj.unreadCount);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleRead = async (row: any) => {
    try {
      const { success, obj } = await readNotice({ messageId: row._id, isRead: true });
      if (success) {
        row.isRead = true;
        ElMessage.success('已读');
      }
    } catch (err) {
      console.log(err);
    }
  };

  onMounted(() => {
    queryList();
    timer.value = setInterval(() => {
      queryList();
    }, 3000);
  });

  onUnmounted(() => {
    clearInterval(timer.value);
  });

  return {
    tableData,
    currentPage,
    total,
    TypeEnums,
    handleSizeChange,
    handleCurrentChange,
    queryList,
    handleRead,
  };
};

export default useNotice;
